import React, { useState, useEffect, useRef } from 'react';
import { useNavigate } from 'react-router-dom';
import profilePhoto from '../assets/images/ProfilePhotoScaylor.png';

const ProfilePhoto = () => {
  const [isOpen, setIsOpen] = useState(false);
  const [userData, setUserData] = useState({ name: '', email: '' });
  const dropdownRef = useRef(null);
  const navigate = useNavigate();

  useEffect(() => {
    const fetchUserData = async () => {
      const token = localStorage.getItem('token');
      if (!token) {
        navigate('/login');
        return;
      }

      try {
        const response = await fetch(`${process.env.REACT_APP_API_URL}/api/users/me`, {
          headers: {
            'Authorization': `Bearer ${token}`,
            'Accept': 'application/json'
          }
        });

        if (response.ok) {
          const data = await response.json();
          setUserData({
            name: data.name || '',
            email: data.email || ''
          });
        }
      } catch (error) {
        console.error('Error fetching user data:', error);
      }
    };

    fetchUserData();
  }, [navigate]);

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
        setIsOpen(false);
      }
    };

    document.addEventListener('mousedown', handleClickOutside);
    return () => document.removeEventListener('mousedown', handleClickOutside);
  }, []);

  const handleLogout = () => {
    localStorage.removeItem('token');
    navigate('/login');
  };

  return (
    <div className="absolute top-6 right-6 z-20" ref={dropdownRef}>
      <div className="relative">
        <div
          onClick={() => setIsOpen(!isOpen)}
          className="w-10 h-10 rounded-full border-2 border-white shadow-md hover:shadow-lg transition-shadow bg-gray-200 overflow-hidden cursor-pointer"
        >
          <img src={profilePhoto} alt="Profile" className="w-full h-full object-cover" />
        </div>

        {isOpen && (
          <div className="absolute right-0 mt-2 w-48 bg-white rounded-lg shadow-lg border border-gray-200 py-1 z-50">
            <div className="px-4 py-3 border-b border-gray-200">
              <div className="text-sm font-semibold">{userData.name || 'User'}</div>
              <div className="text-sm text-gray-500">{userData.email || 'user@example.com'}</div>
            </div>
            <button
              onClick={() => navigate('/settings')}
              className="block w-full text-left px-4 py-2 text-sm text-gray-700 hover:bg-gray-100"
            >
              Settings
            </button>
            
            <a
              href="#help"
              className="block px-4 py-2 text-sm text-gray-700 hover:bg-gray-100"
            >
              Help
            </a>
            
            <button
              onClick={handleLogout}
              className="block w-full text-left px-4 py-2 text-sm text-red-600 hover:bg-gray-100"
            >
              Sign out
            </button>
          </div>
        )}
      </div>
    </div>
  );
};

export default ProfilePhoto; 